<template lang='pug'>
  i.svg-icon.svg-icon-emoji
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(fill-rule='evenodd' clip-rule='evenodd' d='M50.333,91.307C27.142,91.293,8.44,72.74,8.459,49.768 C8.481,27.128,26.935,8.929,49.864,8.935c23.228,0.007,42,18.554,41.974,41.465C91.813,73.201,73.426,91.318,50.333,91.307z M50.286,16.655C31.698,16.677,16.682,31.554,16.69,49.938c0.007,18.371,15.048,33.23,33.645,33.238 c18.681,0.008,33.726-14.896,33.689-33.378C83.99,31.446,68.91,16.634,50.286,16.655z')
      path(fill-rule='evenodd' clip-rule='evenodd' d='M50.038,69.621c-5.472,0.043-10.397-2.008-14.516-5.934 c-1.939-1.85-1.983-4.139-0.299-5.891c1.632-1.695,3.994-1.705,5.973,0.072c3.815,3.426,8.215,4.604,13.113,3.008 c1.829-0.596,3.54-1.77,5.084-2.955c2.208-1.695,4.483-1.852,6.136-0.086c1.7,1.814,1.55,4.111-0.494,6.023 C60.918,67.701,56.017,69.641,50.038,69.621z')
      path(fill-rule='evenodd' clip-rule='evenodd' d='M38.087,44.824c-3.452-0.028-6.138-2.728-6.1-6.136 c0.037-3.37,2.854-6.107,6.235-6.06c3.376,0.047,6.162,2.869,6.123,6.203C44.305,42.237,41.575,44.853,38.087,44.824z')
      path(fill-rule='evenodd' clip-rule='evenodd' d='M68.713,38.776c-0.009,3.41-2.72,6.058-6.184,6.051 c-3.448-0.007-6.187-2.711-6.166-6.09c0.019-3.349,2.835-6.104,6.22-6.086C66.014,32.668,68.722,35.376,68.713,38.776z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
